import { TAB_TO_FIELD_MAP, VALIDATE_RULES_FIELDS } from './constants'
import { createCollector, createValidator } from '../../../../../../../../common/utils/validatorService'

export const isValidFields = createValidator(VALIDATE_RULES_FIELDS)
export const collectFieldsErrors = createCollector(VALIDATE_RULES_FIELDS)

export const validateTabs = (tmpStructure, tabsValidationResult, activeTab) => {
    let activeTabField = TAB_TO_FIELD_MAP[activeTab] || null
    const isValid = isValidFields(tmpStructure, activeTabField)
    const errors = collectFieldsErrors(tmpStructure, activeTabField)

    return {
        tmpStructure,
        errors,
        activeTabHasError: activeTabField && !isValid,
        hasError: !isValid,
    }
}

const loadImage = async url => {
    return new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = () => resolve(image)
        image.onerror = () => reject('Loading image error')
        image.crossOrigin = 'anonymous'
        image.src = url
    })
}

export const splitImage = async (url, { cols = 4, rows = 4 }) => {
    if (!url) throw new Error('url is required')

    const image = await loadImage(url)

    const imagePieces = []
    for (let x = 0; x < cols; ++x) {
        for (let y = 0; y < rows; ++y) {
            const canvas = document.createElement('canvas')

            let widthOfOnePiece = 0
            let heightOfOnePiece = 0
            let widthOffset = 0
            let heightOffset = 0
            // we want to crop square images
            if (image.width > image.height) {
                widthOfOnePiece = image.height / cols
                heightOfOnePiece = image.height / rows
                widthOffset = (image.width - image.height) / 2
            } else {
                widthOfOnePiece = image.width / cols
                heightOfOnePiece = image.width / rows
                heightOffset = (image.height - image.width) / 2
            }

            canvas.width = widthOfOnePiece
            canvas.height = heightOfOnePiece

            const context = canvas.getContext('2d')

            context.drawImage(
                image,
                x * widthOfOnePiece + widthOffset,
                y * heightOfOnePiece + heightOffset,
                widthOfOnePiece,
                heightOfOnePiece,
                0,
                0,
                canvas.width,
                canvas.height,
            )
            const uri = canvas.toDataURL()

            const bytes = atob(uri.split(',')[1])
            const bufferArray = new Uint8Array(bytes.length)
            for (let i = 0, l = bytes.length; i < l; i++) {
                bufferArray[i] = bytes.charCodeAt(i)
            }

            imagePieces.push({
                x,
                y,
                uri,
                bufferArray,
            })
        }
    }
    return imagePieces
}
